import { MealType } from "model/food/types"
import {
  getNutritionPayload,
  getPortionUnitPayload,
} from "./getBaseMealPayloadFromFood"
import { getImagePayload } from "./getImagePayload"
import {
  IAINutritionFactPayload,
  IAIPackageMealPayload,
  IAIScanMealPayload,
  ICreateMealPayload,
  IEdamaMealPayload,
  IMyMealPayload,
  IOpenFoodFactMealPayload,
} from "model/food/types/mealPayload.types"

const getMealPayloadFromMeal = (meal: MealType) => {
  const baseMealPayload = {
    foodId: meal.foodId,
    source: meal.source,
    name: meal.name,
    type: meal.type,
    ...getNutritionPayload(meal),
    ...getPortionUnitPayload(meal),
    ...getImagePayload(meal),
  }

  let finalPayload: ICreateMealPayload

  switch (meal.source) {
    case "EDAMAM":
      finalPayload = {
        ...baseMealPayload,
        source: "EDAMAM",
        units: meal.units,
        brand: meal.brand,
      } satisfies IEdamaMealPayload
      break

    case "MY_FOOD":
      finalPayload = {
        ...baseMealPayload,
        source: "MY_FOOD",
        ingredients: meal.ingredients,
      } satisfies IMyMealPayload
      break

    case "AI_SCAN_MEAL":
      finalPayload = {
        ...baseMealPayload,
        source: "AI_SCAN_MEAL",
        ingredients: meal.ingredients,
      } satisfies IAIScanMealPayload
      break

    case "AI_SCAN_PACKAGE":
      finalPayload = {
        ...baseMealPayload,
        source: "AI_SCAN_PACKAGE",
      } satisfies IAIPackageMealPayload
      break

    case "AI_SCAN_NUTRITION_FACTS":
      finalPayload = {
        ...baseMealPayload,
        source: "AI_SCAN_NUTRITION_FACTS",
      } satisfies IAINutritionFactPayload
      break

    case "OPEN_FOOD_FACTS":
      finalPayload = {
        ...baseMealPayload,
        source: "OPEN_FOOD_FACTS",
        brand: meal.brand,
      } satisfies IOpenFoodFactMealPayload
      break
  }

  return finalPayload
}

export default getMealPayloadFromMeal
